<template> 
  <div class="mb-3" :class="FormDataType.FieldSize">
    <b-form-group
      :class="title_position"
      :label-cols-lg="labels_lg"
      id="example text"
      :label="FormDataType.FieldTitle"
      label-for="text"
    >  

    
        <ckeditor v-model="InputName"
        @input="$emit('input', InputName)"
        
        :disabled="FormDataType.Disabled"
        :editor="editor"></ckeditor>

       

      <div v-if="v.$error" class="invalid-feedback">
        <span v-if="v.required == false">{{  $t("ValidationMessage.required") }}</span>
        <span v-if="v.numeric == false">Bu Alan numeric.</span>
      </div>
    </b-form-group>
  </div> 
</template>

<script>
 
import CKEditor from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
export default {
  data() {
    return {
      InputName: "",
       editor: ClassicEditor, 
       };
  },
  components: {  
      ckeditor: CKEditor.component
  },
  toolbar:  "insertfile undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image | print preview media fullpage | forecolor backcolor emoticons",
 
  props: {
    v: {
      type: Object,
    },
    FormDataType: {},
    FormPost: String,
    Value: null,
    min: String,
    max: String,
    title_position: String,
    labels_lg: Number
  },
  watch: {
    FormPost() {
      this.$v.$touch();
    },
    Value(){
      this.InputName = this.Value;
    }
  },
  created: function () {
    this.InputName = this.Value;
  },
};
</script>
